// Файл: src/context/NotificationContext.js (версия для отладки)

import React, { createContext, useContext, useState, useEffect } from 'react';
import { getMyNotifications, markAllNotificationsAsRead, deleteAllNotifications } from '../api/apiService';
import { useAuth } from './AuthContext';
import { socket } from '../socket';

const NotificationContext = createContext();

export const useNotifications = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const { user } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [eventDetailsToShow, setEventDetailsToShow] = useState(null);

  // загрузка существующих уведомлений
  useEffect(() => {
    if (!user) return;
    getMyNotifications()
      .then((res) => {
        setNotifications(res.data);
        setUnreadCount(res.data.filter((n) => !n.read).length);
      })
      .catch((err) => console.error('Не удалось загрузить уведомления', err));
  }, [user]);

  // подписка на сокет
  useEffect(() => {
    if (!user) return;

    const roomId = user._id || user.id;

    const onConnect = () => {
      console.log(`[Socket.IO] connected ${socket.id}, join room ${roomId}`);
      // если на сервере событие называется иначе — поправь
      socket.emit('joinRoom', roomId);
    };
    const onNewNotification = (n) => {
      console.log('[Socket.IO] new_notification', n);
      setNotifications((prev) => [n, ...prev]);
      setUnreadCount((prev) => prev + 1);
    };
    const onDisconnect = () => {
      console.log('[Socket.IO] disconnected');
    };

    socket.on('connect', onConnect);
    socket.on('new_notification', onNewNotification);
    socket.on('disconnect', onDisconnect);

    return () => {
      socket.off('connect', onConnect);
      socket.off('new_notification', onNewNotification);
      socket.off('disconnect', onDisconnect);
      // socket.disconnect(); // не отключаем общий сокет при размонтировании провайдера
    };
  }, [user]);

  const handleMarkAllAsRead = async () => {
    if (unreadCount === 0) return;
    try {
      setUnreadCount(0);
      setNotifications((prev) => prev.map((n) => ({ ...n, read: true })));
      await markAllNotificationsAsRead();
    } catch (error) {
      console.error('Ошибка при обновлении статуса уведомлений:', error);
    }
  };

  const handleClearAll = async () => {
    try {
      setNotifications([]);
      setUnreadCount(0);
      await deleteAllNotifications();
    } catch (error) {
      console.error('Ошибка при удалении уведомлений:', error);
    }
  };

  const value = {
    notifications,
    unreadCount,
    markAllAsRead: handleMarkAllAsRead,
    clearAll: handleClearAll,
    eventDetailsToShow,
    setEventDetailsToShow,
  };

  return <NotificationContext.Provider value={value}>{children}</NotificationContext.Provider>;
};